import { SessionContext } from './analysisService';

interface CodingReportRequest {
  issueText: string;
  chatGroupId: string;
  sessionContext: SessionContext;
}

interface CodingReportResponse {
  success: boolean;
  report_id: string;
  message: string;
}

class ReportService {
  private baseUrl: string;

  constructor() {
    this.baseUrl =
      process.env.NODE_ENV === 'development'
        ? 'http://localhost:8000'
        : 'https://stronghireai.com';
  }

  async submitCodingReport(
    reportData: CodingReportRequest
  ): Promise<CodingReportResponse> {
    try {
      const response = await fetch(`${this.baseUrl}/report/coding_report/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include',
        body: JSON.stringify(reportData),
      });

      if (!response.ok) {
        throw new Error(
          `Failed to submit report: ${response.status} ${response.statusText}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error submitting coding report:', error);
      throw error;
    }
  }
}

const reportService = new ReportService();
export default reportService;
export type { CodingReportRequest, CodingReportResponse };
